<div class="warning">
  <div class="padd15">
    <img width="250" alt="Thomson Reuters" class="" src="../../assets/img/Thomson-Reuters-logo.svg">
    <h1></h1>
    <div class="annoying-warning">
      <h2 class="Heading">{{Heading}}</h2>
      <p class="Information">{{Information}}</p>
      <!--<h1></h1>
      <button id="connect" type="submit" class="msTeam-btn margTop40" (click)="Close()" *ngIf="CloseButtonVisibility">{{CloseButtonText}}</button>-->
    </div>
  </div>
</div>
